import React, { useMemo, useState, useEffect, useRef } from "react";
import cx from "clsx";
import {
  ConnectCapitalFinancingPromotion,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { http } from "../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../consts/api";
import { useCurrentAccountQuery } from "../../../api/queries/useAccountQuery";
import styles from "../sass/StripeCapitalTile.module.scss";
import PoweredByStripeIcon from "../../../assets/Icons/PoweredByStripeIcon";

const StripeCapitalTile = ({ setStripeCapitalLoaded }) => {
  const { data: account } = useCurrentAccountQuery();
  const isEnabled = account?.globalSettings?.featureFlag?.stripeCapital;
  const [isLoaded, setIsLoaded] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const containerRef = useRef(null);

  const stripeConnectInstance = useMemo(() => {
    if (!isEnabled) return null;
    return loadConnectAndInitialize({
      publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: async () => {
        const res = await http.post(
          HTTP_ENDPOINTS.stripe.capitalAccountSession(),
        );
        return res?.data?.data?.client_secret;
      },
      appearance: {
        variables: {
          colorBackground: "#ffffff",
        },
      },
    });
  }, [isEnabled]);

  useEffect(() => {
    if (!containerRef.current || !isEnabled) return;

    const checkIframeLoaded = () => {
      const iframe = containerRef.current?.querySelector("iframe");
      if (iframe) {
        setIsLoaded(true);
      } else {
        setTimeout(checkIframeLoaded, 100);
      }
    };

    const timer = setTimeout(checkIframeLoaded, 500);
    return () => clearTimeout(timer);
  }, [isEnabled]);

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={styles.bar}
      style={{ display: isLoaded ? "block" : "none" }}
    >
      <button
        className={styles.barHeader}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <span className={cx("flex items-center gap-16 bold", styles.barTitle)}>
          AR Capital <PoweredByStripeIcon />
        </span>
        <i
          className={cx(
            "fa",
            isExpanded ? "fa-chevron-up" : "fa-chevron-down",
            styles.barChevron,
          )}
        />
      </button>
      {isExpanded && stripeConnectInstance && (
        <div className={styles.barContent}>
          <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectCapitalFinancingPromotion
              layout="banner"
              onEligibleFinancingOfferLoaded={({ productType }) => {
                if (productType !== "none") {
                  setStripeCapitalLoaded(true);
                }
              }}
            />
          </ConnectComponentsProvider>
        </div>
      )}
    </div>
  );
};

export default StripeCapitalTile;
